import { FC, Fragment, useEffect } from 'react';
// Components
import Banner from './Banner';
// Utilities
import { scrollToTop } from 'utilities/Utilities';
import About from './About';
import Services from './Services';
import Brands from './Brands';
import ServiceArea from './ServiceArea';
import Contacts from './Contacts';

const HomePage:FC = () => {
  useEffect(() => scrollToTop(), []);

  return (
    <Fragment>
      <Banner />
      <About />
      <Services />
      <Brands />
      <ServiceArea />
      <Contacts />
    </Fragment>
  );
}

export default HomePage;
